import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { isDevEditorHost } from './dev-editor.util';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  // Use the settled auth state (authStateReady + currentUser) rather than the user()
  // observable, whose first emission can be stale right after sign-in — which previously
  // denied a just-signed-in user and required a manual refresh.
  const isAuthenticated = await authService.isAuthenticatedNow();
  if (!isAuthenticated) {
    router.navigate([''], { queryParams: { returnUrl: state.url } });
    return false;
  }
  // DEV EDITOR GATE (release Plan 2). The Dev editor runs unreleased editor code on real projects;
  // only the Zavo team may use it. Never runs on zavo.build, and never in a built app (isRuntime).
  // The team-only page performs the sign-out — a sign-out here would race app.component's auth
  // subscription, which redirects an unauthenticated user to login before this navigation lands.
  if (!environment.isRuntime && isDevEditorHost(location.hostname) && !(await authService.hasZavoTeamClaim())) {
    return router.createUrlTree(['team-only']);
  }
  return true;
};
